
export const getJWT = state => state.get('auth').token;
export const isAuthenticated = state => !!state.get('auth').isAuthenticated;